"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rxjs = require("rxjs");

var scheduler = function scheduler(_ref) {
  var _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? 250 : _ref$debounce,
      _ref$maxDelay = _ref.maxDelay,
      maxDelay = _ref$maxDelay === void 0 ? 500 : _ref$maxDelay;
  return function (observable) {
    return new _rxjs.Observable(function (observer) {
      var asyncResource = null;

      var cleanupResource = function cleanupResource() {
        clearTimeout(asyncResource.debounceTimeout);
        clearTimeout(asyncResource.forceTimeout);
        asyncResource = null;
      };

      var subscriber = observable.subscribe({
        next: function next(value) {
          var notifySubscriber = function notifySubscriber() {
            observer.next(asyncResource.value);
            cleanupResource();
          };

          if (!asyncResource) {
            var debounceTimeout = setTimeout(notifySubscriber, debounce);
            var forceTimeout = setTimeout(notifySubscriber, maxDelay);
            asyncResource = {
              debounceTimeout: debounceTimeout,
              forceTimeout: forceTimeout,
              value: value
            };
          } else {
            clearTimeout(asyncResource.debounceTimeout);
            asyncResource.debounceTimeout = setTimeout(notifySubscriber, debounce);
            asyncResource.value = value;
          }
        }
      });
      return function () {
        subscriber.unsubscribe();
        /* istanbul ignore if */

        if (asyncResource) {
          cleanupResource();
        }
      };
    });
  };
};

var _default = scheduler;
exports.default = _default;